import { Box, styled } from "@mui/material";
import SkeletonComp from "../../../../common/SkeletonComp";

export const MainContainer = styled(Box)(() => ({
  height: "calc(100vh - 200px)",
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

export const PromptsContainer = styled(Box)(() => ({
  display: "flex",
  maxWidth: "890px",
  width: "100%",
  margin: "0 auto",
  columnGap: "1rem",
  marginBottom: "3rem",
}));

export const PromptContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: theme.palette.primary.lighter,
  padding: "1.5rem 1rem",
  height: "9.049rem",
  width: "calc(33.333% - 11px)",
}));

export const InputContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  marginBottom: "1rem",
  height: "4.063rem",
}));

export const HeaderSkeleton = styled(SkeletonComp)(() => ({
  marginBottom: "1rem",
  fontSize: "0.875rem",
}));

export const DescriptionSkeleton = styled(SkeletonComp)(() => ({
  fontSize: "0.875rem",
}));

export const InputSkeleton = styled(SkeletonComp)(() => ({
  maxWidth: "890px",
  width: "100%",
  height: "100%",
}));
export const SkeletonBarHolder = styled("div")`
  margin: 0 0 20px;
  &.small {
    max-width: 250px;
  }
  &.edit {
    > div {
      height: 80px;
      margin: 0 -20px;
      max-width: 100%;
    }
  }
`;
export const SkeletonBarTop = styled("div")`
  flex-grow: 1;
`;
export const SkeletonBar = styled("div")`
  height: 25px;
  position: relative;
  overflow: hidden;
  background-color: rgb(58, 67, 105, 0.08);
  border-radius: 4px;
  max-width: 650px;
  &:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
    animation: shimmer 3s infinite;
    content: '';
  }
  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
 } 
`;
